import type { IFaqQuestion } from '@/shared/model/types/faq';

export const MAIN_PAGE_FAQ_QUESTIONS: IFaqQuestion[] = [
  {
    id: 1,
    active: true,
    title: 'Каких специалистов можно найти на Юрик.ру?',
    text: 'На сервисе представлены юристы и адвокаты, а также юридические компании и адвокатские образования по всем отраслям права',
  },
  {
    id: 2,
    active: false,
    title: 'Как и что проверяете у юристов или адвокатов?',
    text: 'Мы обязательно проверяем образование. Если это адвокат, то его статус. А также сличаем паспортные данные с фотографией и данными профиля',
  },
  {
    id: 3,
    active: false,
    title: 'Как подобрать нужного юриста?',
    text: 'Введите ваш поисковой запрос на главной странице сайта или воспользуйтесь необходимыми фильтрами в каталоге, ознакомьтесь с профилем специалиста и особое внимание уделите отзывам',
  },
  {
    id: 4,
    active: false,
    title: 'Сколько стоят услуги юристов?',
    text: 'Информацию о стоимости услуг вы можете посмотреть в карточке профиля юриста или адвоката (юридической компании или адвокатской конторы)',
  },
  {
    id: 5,
    active: false,
    title: 'Как записаться на прием?',
    text: 'Вы можете записаться на консультацию через календарь на странице профиля юриста',
  },
  {
    id: 6,
    active: false,
    title: 'Можно ли связаться с юристом до записи?',
    text: 'Вы можете обсудить все вопросы со специалистом в онлайн-чате или заказать бесплатный звонок',
  },
  {
    id: 7,
    active: false,
    title: 'Зачем нужен личный кабинет?',
    text: 'В нем вы сможете отслеживать записи к специалистам, оставлять отзывы о их работе, обсуждать детали проблемы через онлайн-чат или по телефону. А также позволяет вам получить поддержку сервиса в случае возникновения проблем с юристом',
  },
  {
    id: 8,
    active: false,
    title: 'Нужна ли регистрация на сервисе?',
    text: 'Для выбора специалиста и заказа обратного звонка регистрация необязательна, но зарегистрированный пользователь может отслеживать записи к специалистам, оставлять отзывы о их работе, обсуждать детали через онлайн-чат или по телефону, а также позволяет вам получить поддержку сервиса в случае возникновения проблем с юристом',
  },
  {
    id: 9,
    active: false,
    title: 'На основании чего формируется ваш рейтинг?',
    text: 'На позиции в рейтинге для специалистов влияет несколько факторов, самые основные: подтвержденные документы специалиста, соответствие цен на услуги в карточке с ценами в реальности, отзывы и оценки пользователей в Юрик.ру',
  },
];

export const FOR_LAYWERS_FAQ_QUESTIONS: IFaqQuestion[] = [
  {
    id: 1,
    active: true,
    title: 'Как попасть в каталог Юрик.ру?',
    text: 'Необходимо зарегистрироваться и предоставить необходимые данные для проверки аккаунта',
  },
  {
    id: 2,
    active: false,
    title: 'Что будет доступно после проверки?',
    text: 'После успешного прохождения проверки ваш профиль моментально появится в каталоге и будет доступен для поиска пользователям сервиса. Они смогут проявить интерес к указанным в профиле услугам и написать вам напрямую через онлайн-чат',
  },
  {
    id: 3,
    active: false,
    title: 'Как открыть запись на приём клиентов?',
    text: 'После успешного прохождения проверки вам необходимо связаться с отделом клиентского сервиса по телефону: +7 (499) 346-63-00 и запросить коммерческое предложение в вашем регионе',
  },
  {
    id: 4,
    active: false,
    title: 'В вашем каталоге представлены только частные юристы?',
    text: 'Мы публикуем профили как частных, так и работающих в компаниях юристов и адвокатов, а ещё и сами юридические компании и адвокатские образования (коллегии, бюро, конторы)',
  },
  {
    id: 5,
    active: false,
    title: 'Какие данные необходимо предоставить?',
    text: 'Для быстрого старта вам необходимо указать все данные в&nbsp;разделе &laquo;Личный кабинет&raquo; &rarr; &laquo;Профиль&raquo; &rarr; &laquo;Основные сведения&raquo;',
  },
  {
    id: 6,
    active: false,
    title: 'Сколько по времени длится проверка данных аккаунта?',
    text: 'Проверка обычно длится около 2-х часов в рабочее время с 9:00 до 18:00, ежедневно без выходных (за исключением праздничных дней)',
  },
  {
    id: 7,
    active: false,
    title: 'Какие требования для юр. компании и адвокатских контор?',
    text: 'Необходимо в личном кабинете добавить к профилю компании хотя бы 1 сотрудника, коллегу или партнера',
  },
];
